// Nav entry of Listen (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
// Kuuntele: show lines with Peterson's recordings, scene by scene, and listen-and-translate.
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'listen',
  path: '/listen',
  icon: 'listen',
  group: 'practice',
  phone: 'more',
  // only the listening exercise is a study session (listen/Practice.tsx useRun: location state
  // lxRun); the scripts keep the player bar (loop, Hidas, stop)
  session: ({ state }) => (state as { lxRun?: unknown } | null)?.lxRun !== undefined,
  order: 300,
  load: () => import('./Listen'),
});
